import { UpperCasePipe } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ExternalLinksInterface } from 'src/app/interfaces/external-links.interface';
import { CommonAlertService } from 'src/app/services/alert/alert.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SiteLocationService } from 'src/app/services/site-location/site-location.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
    selector: 'navbar-state-selector',
    templateUrl: './navbar-state-selector.component.html',
    styleUrls: ['./navbar-state-selector.component.scss'],
    standalone: true,
    imports: [
        UpperCasePipe,
    ]
})
export class NavbarStateSelectorComponent implements OnInit {

    private popoverCtrl = inject(PopoverController);

    public jurisdictionExternalLinks: ExternalLinksInterface[];
    public selectedState: string;
    public states: { [key: string]: string }[];
    public statesMap: { [key: string]: string };

    constructor(
        private config: ConfigService,
        private commonAlertService: CommonAlertService,
        private events: EventsService,
        private siteLocationService: SiteLocationService,
        private userSession: UserSessionService,
    ) {
    }

    ngOnInit() {
        let statesMap: Record<string, string>;

        const raw = this.config.getConfig().JURISDICTION_STATES_SELECTETOR;

        if (raw && raw !== 'undefined') {
            try {
                statesMap = JSON.parse(raw);
            } catch {
                statesMap = { PA: 'Pennsylvania', NJ: 'New Jersey' };
            }
        } else {
            statesMap = { PA: 'Pennsylvania', NJ: 'New Jersey' };
        }

        this.statesMap = statesMap;
        const stateKeys = Object.keys(statesMap);
        this.states = stateKeys.map(key => ({ code: key, value: statesMap[key] }));

        this.events.subscribe("event:config:reload", () => {
            this.config.isLoaded().then(() => {
                this.getJurisdictionExternalLinks();
            });
        });

        this.config.isLoaded().then(() => {
            this.getJurisdictionExternalLinks();
        });
    }

    public getJurisdictionExternalLinks() {
        const externalLinks = this.config?.getExternalLinks()?.payload;
        this.jurisdictionExternalLinks = externalLinks?.filter(link =>
            link.isHamburgerMenu === 1 && link.code === 'jurisdiction' && !!link.label);
        if (this.jurisdictionExternalLinks?.length > 0) {
            const stateKeys = Object.keys(this.statesMap);
            this.selectedState = stateKeys.filter(key => key != this.jurisdictionExternalLinks[0]?.label)[0];
        }
    }

    public onSelectState(code: string): any {
        const jurisdictionExternalLinks = this.jurisdictionExternalLinks;
        if (code && code != this.selectedState && jurisdictionExternalLinks?.length > 0) {

            setTimeout(() => this.popoverCtrl.dismiss(), 500);

            if (this.userSession.isAuthenticated()) {
                return this.presentAlert(code);
            }

            return this.changeState(code);
        }
    }

    async presentAlert(state: string) {
        await this.commonAlertService.changeJurisdiction(() => this.changeState(state));
    }

    public changeState(newState: string): void {
        this.selectedState = newState;
        const url = this.jurisdictionExternalLinks[0]?.url;
        this.siteLocationService.changeState(url, this.selectedState);
    }
}